import { Box } from "@mui/material";

/** Complementary three-orb palettes; adjacent cards alternate cool and warm. */
export const ORB_PALETTES = {
  cool: ["#818cf8", "#22d3ee", "#a78bfa"],
  warm: ["#fb923c", "#fb7185", "#fbbf24"],
};

/** Orb placement pooled toward the edges so foreground text stays on white. */
const POSITIONS = [
  { top: "-28%", left: "42%", dur: "18s" },
  { top: "34%", left: "56%", dur: "22s" },
  { top: "20%", left: "-24%", dur: "20s" },
];

/**
 * Blurred color orbs drifting behind content under a frost veil, so overlaid
 * text stays legible. Mirrors the personalization page's notification-card
 * background. Fills its positioned parent; give the parent `overflow: hidden`.
 *
 * @param {{ palette?: "cool"|"warm"|string[], veil?: number, blur?: number, opacity?: number }} props
 */
const DriftingOrbs = ({ palette = "cool", veil = 0.46, blur = 32, opacity = 0.42 }) => {
  const colors = Array.isArray(palette) ? palette : ORB_PALETTES[palette] || ORB_PALETTES.cool;
  return (
    <Box aria-hidden sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none" }}>
      {POSITIONS.map((p, index) => {
        const color = colors[index % colors.length];
        return (
          <Box
            key={index}
            sx={{
              position: "absolute",
              top: p.top,
              left: p.left,
              width: "70%",
              aspectRatio: "1",
              borderRadius: "50%",
              background: `radial-gradient(circle, ${color} 0%, ${color}00 68%)`,
              // Static on purpose: a blurred layer composites once and caches,
              // but animating it re-rasterizes every frame and crash-loops
              // iOS Safari's compositor (the ConciergeOrbs failure mode).
              filter: `blur(${blur}px)`,
              opacity,
            }}
          />
        );
      })}
      <Box sx={{ position: "absolute", inset: 0, backgroundColor: `rgba(255, 255, 255, ${veil})` }} />
    </Box>
  );
};

export default DriftingOrbs;
